import { Field } from "./Field";
import { IElementContainer } from "./ElementContainer";
import { ClosingContainer } from "./ClosingContainer";

export interface IFieldSetConfig
{
	label?:string;
	fields:Field[];
	orderId:number;
}

export class FieldSet extends ClosingContainer implements IElementContainer
{
	private _fieldsElement: HTMLElement;

	private _fields: {[id: string]: Field};

	constructor(config:IFieldSetConfig, onChange:Function)
	{
		super({
			scriptId: "fieldset-header",
			label: config.label
		});

		const nextStepDiv = this.element.querySelector('[data-type="nextStep"]');

		nextStepDiv.setAttribute("data-target", (config.orderId+1).toString());
		this.element.setAttribute("data-orderId", config.orderId.toString());

		this._fieldsElement = <HTMLElement>this.element.querySelector("[data-fields]");
		this._fields = {};

		const fieldsConfig = config.fields;

		if (fieldsConfig)
		{
			for (let i = 0; i < fieldsConfig.length; i++)
			{
				var fieldConfig = fieldsConfig[i];
				var field = new Field(fieldConfig, config.label);

				if (onChange)
				{
					field.input.changeSignal.add(onChange);
				}

				this._fieldsElement.appendChild(field.element);

				this._fields[field.id] = field;
			}
		}
	}

	public get fields():{[id:string]:Field}
	{
		return this._fields;
	}
}